import React from "react";
import { Header, Icon } from "semantic-ui-react";
import userManager from '../userManager';

export default class GoToLogin extends React.Component {

    componentDidMount() {
        var args = {
            useReplaceToNavigate: true // sovrascrive la history: https://github.com/IdentityModel/oidc-client-js/issues/896
        };
    
        userManager.signinRedirect(args);
    }

    render() {
        return (
            <Header icon={true} textAlign="center">
                <Icon name="sign-in" />
                Ti stiamo reindirizzando verso il login ...
            </Header>
        );
    }
}